<div
  class="w-80 hidden lg:flex flex-col border-l border-neutral-3 bg-white dark:bg-neutral-2 overflow-y-auto h-full"
>
  <div class="p-6 flex flex-col gap-6">
    <!-- Opportunity context header -->
    <div>
      <h2 class="text-lg font-bold text-neutral-12 mb-4">À propos de l'opportunité</h2>

      <!-- Property Explore Card -->
      <etxe-property-explore-card [property]="property()" [compact]="true" />
    </div>

    <!-- Actions -->
    <div class="border-t border-neutral-3 pt-6 flex flex-col gap-3">
      <a
        [routerLink]="['/properties', property()._id]"
        mat-flat-button
        class="primary w-full !py-4 font-bold hover:brightness-105 transition-all text-sm text-center flex items-center justify-center"
      >
        Consulter la fiche détaillée
      </a>
    </div>

    <!-- Section: Organisation de la visite (Résumé) -->
    <div class="border-t border-neutral-3 pt-6 flex flex-col gap-3">
      <div class="flex items-center justify-between">
        <h3 class="text-sm font-bold text-neutral-12 m-0 flex items-center gap-2">
          <mat-icon class="text-primary-11 text-base!">event</mat-icon>
          <span>Visite du bien</span>
        </h3>

        @if (appointment(); as appt) {
          @if (isConfirmed()) {
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-jade-3 text-jade-11 dark:bg-jade-9/20 dark:text-jade-11 flex items-center gap-1"
            >
              <mat-icon class="text-xs! w-3! h-3!">check_circle</mat-icon>
              <span>Confirmée</span>
            </span>
          } @else if (isProposed()) {
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-3 text-amber-11 dark:bg-amber-9/20 dark:text-amber-11 flex items-center gap-1"
            >
              <mat-icon class="text-xs! w-3! h-3!">schedule</mat-icon>
              <span>Créneaux proposés</span>
            </span>
          } @else if (isRescheduled()) {
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-orange-3 text-orange-11 dark:bg-orange-9/20 dark:text-orange-11 flex items-center gap-1"
            >
              <mat-icon class="text-xs! w-3! h-3!">event_repeat</mat-icon>
              <span>À reprogrammer</span>
            </span>
          } @else if (isCompleted()) {
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-blue-3 text-blue-11 dark:bg-blue-9/20 dark:text-blue-11 flex items-center gap-1"
            >
              <mat-icon class="text-xs! w-3! h-3!">task_alt</mat-icon>
              <span>Effectuée</span>
            </span>
          } @else if (isCancelled()) {
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-red-3 text-red-11 dark:bg-red-9/20 dark:text-red-11"
            >
              Annulée
            </span>
          }
        } @else {
          <span class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-neutral-3 text-neutral-10">
            Non planifiée
          </span>
        }
      </div>

      <div
        class="p-3.5 rounded-xl border border-neutral-3 bg-neutral-1/50 dark:bg-neutral-2/50 flex flex-col gap-3"
      >
        @if (!appointment()) {
          <p class="text-xs text-neutral-11 m-0">
            @if (isOwner()) {
              Aucun créneau de visite n'a encore été proposé.
            } @else {
              En attente d'une proposition de créneaux par le propriétaire.
            }
          </p>
          @if (isOwner()) {
            <button
              type="button"
              mat-stroked-button
              class="w-full !py-2 text-xs font-bold text-primary hover:bg-primary-9/10 flex items-center justify-center gap-1.5"
              (click)="onProposeVisit()"
            >
              <mat-icon class="text-sm!">add_circle_outline</mat-icon>
              <span>Proposer une visite</span>
            </button>
          }
        } @else if (isProposed()) {
          <div class="flex flex-col gap-2.5">
            <p class="text-xs text-neutral-11 m-0">
              @if (isOwner()) {
                {{ proposedSlotsCount() }} créneau(x) transmis à l'agent. En attente de sa réponse.
              } @else {
                {{ proposedSlotsCount() }} créneau(x) proposés par le propriétaire.
              }
            </p>
            @if (deadline(); as target) {
              <aura-countdown
                [targetDate]="target"
                variant="banner"
                [prefix]="isOwner() ? 'Délai accordé à l\'agent :' : 'Temps restant pour répondre :'"
              ></aura-countdown>
            }
            <button
              type="button"
              mat-flat-button
              class="primary w-full !py-2 text-xs font-bold flex items-center justify-center gap-1.5"
              (click)="openVisitModal.emit()"
            >
              <mat-icon class="text-sm!">
                {{ isOwner() ? 'visibility' : 'event_available' }}
              </mat-icon>
              <span>{{ isOwner() ? 'Voir les créneaux' : 'Choisir un créneau' }}</span>
            </button>
          </div>
        } @else if (isRescheduled()) {
          <div class="flex flex-col gap-2.5">
            <p class="text-xs text-neutral-11 m-0">
              @if (isOwner()) {
                L'agent a demandé d'autres disponibilités pour la visite.
              } @else {
                Votre demande de nouveaux créneaux a été transmise au propriétaire.
              }
            </p>
            @if (deadline(); as target) {
              <aura-countdown
                [targetDate]="target"
                variant="banner"
                [prefix]="isOwner() ? 'Temps restant pour répondre :' : 'Délai accordé au propriétaire :'"
              ></aura-countdown>
            }
            @if (rescheduleReason(); as reason) {
              <div
                class="p-2 rounded-lg bg-neutral-2 border border-neutral-4 text-[11px] italic text-neutral-11"
              >
                « {{ reason }} »
              </div>
            }
            <button
              type="button"
              mat-flat-button
              class="primary w-full !py-2 text-xs font-bold flex items-center justify-center gap-1.5"
              (click)="openVisitModal.emit()"
            >
              <mat-icon class="text-sm!">event_repeat</mat-icon>
              <span>{{ isOwner() ? 'Proposer de nouveaux créneaux' : 'Voir les détails' }}</span>
            </button>
          </div>
        } @else if (isConfirmed()) {
          <div class="flex flex-col gap-2.5">
            @if (confirmedSlot(); as slot) {
              <div
                class="p-2.5 rounded-lg bg-jade-2/50 dark:bg-jade-9/10 border border-jade-4/40 flex flex-col gap-1"
              >
                <div class="flex items-center gap-1.5 text-jade-11 font-bold text-xs capitalize">
                  <mat-icon class="text-sm!">calendar_today</mat-icon>
                  <span>{{ slot.startAt | date: 'EEEE d MMMM yyyy' : '' : 'fr-FR' }}</span>
                </div>
                <div class="flex items-center gap-1.5 text-neutral-11 text-xs pl-5">
                  <mat-icon class="text-xs! w-3! h-3!">schedule</mat-icon>
                  <span>{{ slot.startAt | date: 'HH:mm' }} - {{ slot.endAt | date: 'HH:mm' }}</span>
                </div>
              </div>
            }
            <div class="flex flex-col gap-1.5">
              <button
                type="button"
                mat-stroked-button
                class="w-full !py-1.5 text-xs font-semibold text-neutral-11 hover:text-neutral-12"
                (click)="openVisitModal.emit()"
              >
                <span>Détails de la visite</span>
              </button>
              @if (!isOwner() && isVisitPassed()) {
                <button
                  type="button"
                  mat-flat-button
                  class="primary w-full !py-1.5 text-xs font-bold"
                  (click)="onAdjustFinalOffer()"
                >
                  <span>Avis de valeur & offre finale</span>
                </button>
              }
            </div>
          </div>
        } @else if (isCompleted()) {
          <div class="flex flex-col gap-2">
            @if (confirmedSlot(); as slot) {
              <p class="text-xs text-neutral-11 m-0">
                Visite effectuée le <strong>{{ slot.startAt | date: 'd MMMM yyyy' : '' : 'fr-FR' }}</strong
                >.
              </p>
            }

            @if (isOfferSubmitted()) {
              <div class="p-3 rounded-xl bg-purple-1/50 border border-purple-4/60 flex flex-col gap-1.5">
                <div class="flex items-center gap-1.5 text-purple-11 font-semibold text-xs">
                  <mat-icon class="size-4 !text-base">verified</mat-icon>
                  <span>Offre finale transmise</span>
                </div>
                <p class="text-xs text-neutral-11 m-0 leading-relaxed">
                  @if (isOwner()) {
                    L'agent a transmis son avis de valeur et son barème définitif. Vous pouvez comparer les
                    offres des candidats pour attribuer le mandat.
                  } @else {
                    Votre avis de valeur et votre barème définitif ont été transmis. Le propriétaire délibère
                    actuellement sur l'attribution du mandat.
                  }
                </p>
              </div>
            }

            @if (deadline(); as target) {
              <aura-countdown
                [targetDate]="target"
                variant="banner"
                [prefix]="countdownPrefix()"
              ></aura-countdown>
            }

            <div class="flex flex-col gap-1.5">
              <button
                type="button"
                mat-stroked-button
                class="w-full !py-1.5 text-xs font-semibold text-neutral-11 hover:text-neutral-12"
                (click)="openVisitModal.emit()"
              >
                <span>Historique de la visite</span>
              </button>
              @if (!isOwner()) {
                <button
                  type="button"
                  mat-flat-button
                  class="primary w-full !py-1.5 text-xs font-bold"
                  (click)="onAdjustFinalOffer()"
                >
                  <span>Avis de valeur et offre finale</span>
                </button>
              } @else if (isOfferSubmitted()) {
                <a
                  [routerLink]="['/properties', property()._id]"
                  mat-flat-button
                  class="primary w-full !py-1.5 text-xs font-bold flex items-center justify-center"
                >
                  <span>Comparer les candidatures</span>
                </a>
              }
            </div>
          </div>
        } @else if (isCancelled()) {
          <div class="flex flex-col gap-2">
            <p class="text-xs text-neutral-10 m-0">Cette visite a été annulée.</p>
            @if (isOwner()) {
              <button
                type="button"
                mat-stroked-button
                class="w-full !py-1.5 text-xs font-bold text-primary hover:bg-primary-9/10"
                (click)="openVisitModal.emit()"
              >
                <span>Reprogrammer une visite</span>
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
